"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dateFormat = dateFormat;
exports.datePadding = datePadding;

/**
 * 日期格式化方法
 * 
 * 日期格式:
 * 
 * yyyy 四位数字的年份
 * mm 月份
 * dd 日期
 * hh 小时
 * MM 分钟
 * ss 秒数
 *
 * @export
 * @param {DateLike} date
 * @param {string} format 
 * @return {*} 
 */
function dateFormat(date, format) {
  var dateObj = date instanceof Date ? date : new Date(date);
  var year = dateObj.getFullYear().toString();
  var month = datePadding(dateObj.getMonth() + 1);
  var day = datePadding(dateObj.getDate());
  var hours = datePadding(dateObj.getHours());
  var minutes = datePadding(dateObj.getMinutes());
  var seconds = datePadding(dateObj.getSeconds());
  var dateStr = format.replace(/yyyy/g, year);
  dateStr = dateStr.replace(/mm/g, month);
  dateStr = dateStr.replace(/dd/g, day);
  dateStr = dateStr.replace(/hh/g, hours);
  dateStr = dateStr.replace(/MM/g, minutes);
  dateStr = dateStr.replace(/ss/g, seconds);
  return dateStr;
}

function datePadding(num) {
  return "0".concat(num).substr(-2);
}


//////////////////
// WEBPACK FOOTER
// ./~/@weike/toolkit/lib/date/index.js
// module id = 620
// module chunks = 6